import { createApp } from 'vue';
import DocsApp from './DocsApp.vue';
import { router } from './router';
import { store } from './store';
import RaiseOrdinal from './directives/raise-ordinal';
import AutoFocus from './directives/auto-focus';
import ClickOutside from './directives/click-outside';

const app = createApp(DocsApp).use(router).use(store);

app.directive('raise-ordinal', RaiseOrdinal);
app.directive('auto-focus', AutoFocus);
app.directive('click-outside', ClickOutside);

app.mount('#app');
